import React from 'react'
import styled from 'styled-components'
import { Hash } from 'phosphor-react'
import { getAutoNumberInspectionDisplay } from 'utility'

const AutoNumberCard = styled.div`
    border: 1px solid #c7d2fe;
    border-left: 4px solid #4f46e5;
    border-radius: 12px;
    background: linear-gradient(135deg, #f8faff 0%, #eef2ff 55%, #f5f3ff 100%);
    padding: 14px 16px;
    box-shadow: 0 2px 10px rgba(79, 70, 229, 0.1);
    width: 100%;
`

const CardRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
`

const LeftBlock = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
`

const IconWrap = styled.div`
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(145deg, #4f46e5 0%, #6366f1 100%);
    color: #fff;
    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.35);
`

const QuestionTitle = styled.div`
    flex: 1;
    min-width: 0;
    font-size: 0.92rem;
    font-weight: 600;
    color: #4338ca;
    line-height: 1.45;
    word-break: break-word;

    p,
    span,
    strong,
    em {
        color: #4338ca;
    }
`

const AssignedValue = styled.div`
    flex-shrink: 0;
    font-size: 1.05rem;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    letter-spacing: 0.04em;
    color: #312e81;
    padding: 6px 12px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #a5b4fc;
    white-space: nowrap;
`

export const AutoNumberInspectionDisplay = ({ item, className = '' }) => {
    const display = getAutoNumberInspectionDisplay(item)
    const faq = item?.FAQ || ''

    return (
        <AutoNumberCard className={className}>
            <CardRow>
                <LeftBlock>
                    <IconWrap aria-hidden>
                        <Hash size={22} weight="bold" />
                    </IconWrap>
                    {faq ? (
                        <QuestionTitle
                            dangerouslySetInnerHTML={{ __html: faq }}
                        />
                    ) : null}
                </LeftBlock>
                {display.hasValue ? (
                    <AssignedValue>{display.value}</AssignedValue>
                ) : null}
            </CardRow>
        </AutoNumberCard>
    )
}
